import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';

const RequireAuth = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { company } = useParams();

  if (!isAuthenticated) {
    return <Navigate to={`/${company}/login`} />;
  }

  return children;
};

export default RequireAuth;
